import React, { useEffect, useState } from "react";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ticketsType } from "../../../../services/TicketsServices";
import PageWrapper from "../../../../common/PageWrapper/PageWrapper";

function FieldItem({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography sx={{ color: "#777", fontSize: 12, mb: 0.5 }}>{label}</Typography>
      <Typography sx={{ color: "#111" }}>{value ?? "-"}</Typography>
    </Grid>
  );
}

function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

export default function TicketTypeDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    ticketsType("get", null, null, id)
      .then((res) => {
        if (cancelled) return;
        setData(res?.data || null);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch ticket type detail:", err);
        if (cancelled) return;
        setData(null);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <PageWrapper>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">Ticket Fee Detail</Typography>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      <Card className={"box-shadow"} sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <FieldItem label="Code" value={data?.code} />
          <FieldItem label="Name" value={data?.name} />
          <FieldItem label="Description" value={data?.description} />
          <FieldItem label="Fee" value={data?.fee} />
          <FieldItem label="Museum Type" value={data?.museum_type?.name ?? data?.museum_type?.code ?? "-"} />
          <FieldItem label="Visitor Type" value={data?.visitor_type?.name ?? data?.visitor_type?.code ?? "-"} />
        </Grid>
      </Card>
    </PageWrapper>
  );
}
